export const ErrorCode = {
    centralDepLimitErrorCodes: ['275', 'DEPOSIT_EXCEEDS_BUDGET'],
    purchaseLimitsErrorCodes: ['511', '789', '790', '791', '792', '793'],
    rgLimitsErrorCodes: ['116', '117', '118', '119'],
    instrumentDepositLimitExceeded: '783',
    creditCardBlocked: '620',
    amlNetDepLimitErrorCodes: ['150', '151'],
    affordibilityDepLimitErrorCodes: ['156', '157', '172', '173', '174', '175', '176'],
    affordibilityGrossLimitErrorCodes: ['177', '178', '179', '180', '181', '183', '190', '193', '194'],
    svocAffordibilityErrorCodes: ['160', '161', '166', '167', '182'],
    svocAffordibility182ErrorCodes: '182',
    prorgDepLimitErrorCode: ['152', '155'],
    gamerscardErrorCodes: ['1000', '1001', '2000', '2001', '2003', '2005'],
    gamingLimitsErrorCode: '970',
    intensivePlayerCode: '1121',
    riskyPlayerCode: '1120',
    sportsLimitsErrorCode: '971',
    gamingLimitsNotConfigured: '972',
    belgiumAffLimitErrorCode: '126',
    adaMessageCode: '168',
    playBreakCode: '169',
    arcErrorCode: '170',
    sessionTimeoutErrorCode: '171',
    doNotHonorMessageCode: [
        '14',
        '100/1',
        '100/2',
        '100/3',
        '100/4',
        '100/5',
        '100/6',
        '100/7',
        '100/12',
        '100/13',
        '100/14',
        '100/15',
        '100/19',
        '100/21',
        '100/30',
        '100/39',
        '100/41',
        '100/43',
        '100/46',
        '100/52',
        '100/53',
        '100/54',
        '100/55',
        '100/57',
        '100/58',
        '100/59',
        '100/61',
        '100/62',
        '100/63',
        '100/64',
        '100/65',
        '100/70',
        '100/71',
        '100/75',
        '100/76',
        '100/77',
        '100/78',
        '100/79',
        '100/80',
        '100/81',
        '100/82',
        '100/84',
        '100/86',
        '100/87',
        '100/88',
        '100/89',
        '100/91',
        '100/92',
        '100/93',
        '100/94',
        '100/96',
        '100/1A',
        '100/B1',
        '100/N0',
        '100/N3',
        '100/N4',
        '100/P2',
        '100/P5',
        '100/P6',
        '100/R0',
        '100/R1',
        '100/R3',
        '100/Z3',
        '100/6P',
        '100/05',
    ],
    insufficientFundsErrorMessageCode: ['8', '100/51'],
    invalidCvvCode: ['100/82', '100/N7'],
    cdrMessagesErrorCodes: ['THIRDPARTY_ERROR', 'PLAYER_NOT_REGISTERED'],
    ServiceUnavailable: '503',
    AMLNetDepositLimitsExceeded_150: '150',
    AMLNetDepositLimitsExceeded_151: '151',
    AffordibilityNetDepositLimitsExceeded_156: '156',
    AffordibilityNetDepositLimitsExceeded_157: '157',
    AffordibilityNetDepositLimitsExceeded_175: '175',
    AffordibilityNetDepositLimitsExceeded_172: '172',
    AffordibilityNetDepositLimitsExceeded_176: '176',
    AffordibilityGrossDepositLimitsExceeded_177: '177',
    AffordibilityGrossDepositLimitsExceeded_178: '178',
    AffordibilityGrossDepositLimitsExceeded_179: '179',
    AffordibilityGrossDepositLimitsExceeded_180: '180',
    AffordibilityGrossDepositLimitsExceeded_181: '181',
    GroupBasedAffGrossDepositLimitsExceeded_183: '183',
    AffordabilityMaxLossLimitsuggestion: '187',
    AffordabilityGroupBasedLimit: '182',
    SvocAffordibilityNetDepositLimitsExceeded_161: '161',
    SvocAffordibilityNetDepositLimitsExceeded_160: '160',
    ValidationError_400: '400',
    AffordabilityBannerlinks_176: '176',
    AffordabilityButtons_173: '173',
    maxFailDepEnhancementErrorCode: '1180',
    MaxLossLimitMonthlyExceeded_184: '184',
    SvocPurchaseLimits: ['701', '707', '708', '709'],
    SvocTxnLimits: ['702', '703', '704', '705'],
    ParRiskChecksFailure: ['795', '100/795', '796', '100/796', '797', '100/797', '778', '100/778'],
    ParRiskChecksRgClosedFailure: ['764', '100/764'],
    PIX_PAGSEGURO: ['10051', '210337', '210340', '210341'],
};

export const ErrorTemplate = {
    aml_limit_exceeded: 'aml_limit_exceeded',
    svocAffordabilityError_aml_limit_exceeded: 'aml_limit_exceeded',
    maxFailDepEnhancementErrorTemplate: 'max_fail_dep_enhancement_message',
};
export const GENERIC_ERROR_MESSAGES = {
    TRY_ANOTHER_METHOD: 'PARTY.CASHIER.web.deposit.ach_interchecks.try_another_method',
    INSUFFICIENT_FUNDS: 'PARTY.CASHIER.web.deposit.ach_interchecks.insufficient_funds',
    DEPOSITS_NOT_ACCEPTED: 'PARTY.CASHIER.web.deposit.ach_interchecks.deposit_not_accepted',
    TROUBLE_TO_CONNECT: 'PARTY.CASHIER.web.deposit.ach_interchecks.trouble_to_connect',
    ACCOUNT_ALREADY_CONNECTED: 'PARTY.CASHIER.web.deposit.ach_interchecks.account_already_connected',
    ACCOUNT_BLOCKED: 'PARTY.CASHIER.web.deposit.ach_interchecks.account_blocked',
};

export const INTERCHECKS_ACH_ERROR_CODES: any = {
    ERR_ACCOUNT_BALANCE_THRESHOLD: GENERIC_ERROR_MESSAGES.INSUFFICIENT_FUNDS,
    ERR_ACCOUNT_BALANCE_UNAVAILABLE: GENERIC_ERROR_MESSAGES.TRY_ANOTHER_METHOD,
    ERR_INSUFFICIENT_FUNDS: GENERIC_ERROR_MESSAGES.INSUFFICIENT_FUNDS,
    ERR_ACCOUNT_RISK_BANK_BALANCE_THRESHOLD: GENERIC_ERROR_MESSAGES.DEPOSITS_NOT_ACCEPTED,
    ERR_ACCOUNT_RISK_THRESHOLD: GENERIC_ERROR_MESSAGES.DEPOSITS_NOT_ACCEPTED,
    ERR_ACCOUNT_RISK_METRICS_UNAVAILABLE: GENERIC_ERROR_MESSAGES.TROUBLE_TO_CONNECT,
    ERR_ACCOUNT_RISK_LEVEL_NOT_CONFIGURED: GENERIC_ERROR_MESSAGES.TRY_ANOTHER_METHOD,
    ERR_ACCOUNT_SHARING_LIMIT_EXCEEDED: GENERIC_ERROR_MESSAGES.ACCOUNT_ALREADY_CONNECTED,
    ERR_BANK_ACCOUNT_USER_BLOCKED: GENERIC_ERROR_MESSAGES.ACCOUNT_BLOCKED,
    ERR_BANK_ACCOUNT_BLOCKED: GENERIC_ERROR_MESSAGES.ACCOUNT_BLOCKED,
    ERR_ACCOUNT_NAME_MISMATCH: 'PARTY.CASHIER.web.deposit.ach_interchecks.account_name_mismatch',
    ERR_ACCOUNT_TYPE_RESTRICTED: 'PARTY.CASHIER.web.deposit.ach_interchecks.account_type_restricted',
    ERR_USER_EXITED_PLAID: 'PARTY.CASHIER.web.deposit.ach_interchecks.user_exited_plaid',
    ERR_INVALID_ACCOUNT_ID: 'PARTY.CASHIER.web.deposit.ach_interchecks.invalid_accountid',
    DEFAULT: GENERIC_ERROR_MESSAGES.TRY_ANOTHER_METHOD,
};

export class ResponseStatus {
    public static SUCCESS = 'SUCCESS';
    public static FAILURE = 'FAILURE';
    public static PENDING = 'PENDING';
    public static POST_REDIRECT = 'POST_REDIRECT';
    public static REDIRECT = 'REDIRECT';
    public static THREEDS2_REDIRECT = '3DS2_REDIRECT';
    public static REDIRECT_BANK = 'REDIRECT_BANK';
    public static BANK_DETAIL_MISMATCH = 'BANK_DETAIL_MISMATCH';
}
